module.exports = __webpack_public_path__ + "img/serial-numbers.78adf415.svg";